<i18n>
{
  "cl": {
    "alreadyPaid": "¿Ya pagó?",
    "backButton": "Volver",
    "contactButton": "Contacto",
    "contactMethod": "Medio de contacto",
    "debtButton": "Deuda",
    "dni":"Rut",
    "gotAnswerFromClient": "¿Cliente contesta?",
    "isAbleToPay": "¿Puede pagar?",
    "isImportant": "¿Es importante?",
    "nextCollectionDate": "Próxima gestión",
    "no": "No",
    "null": "No aplica",
    "paymentsButton": "Pagos",
    "phone":"Teléfono",
    "willPayAt": "¿Comprometió fecha?",
    "yes": "Sí"
  },
  "pe": {
    "address": "Dirección",
    "contactButton": "Contacto",
    "debtButton": "Deuda",
    "paymentsButton": "Pagos",
    "contactMethod": "Medio de contacto",
    "gotAnswerFromClient": "¿Cliente contesta?",
    "willPayAt": "¿Comprometió fecha?",
    "isAbleToPay": "¿Puede pagar?",
    "isImportant": "¿Es importante?",
    "alreadyPaid": "¿Ya pagó?",
    "no": "No",
    "null": "No aplica",
    "nextCollectionDate": "Próxima gestión",
    "backButton": "Volver",
    "dni": "DNI",
    "phone": "Teléfono",
    "yes": "Sí"
  },
  "br": {
    "address": "Endereço",
    "contactButton": "Contato",
    "debtButton": "Dívida",
    "paymentsButton": "Pagos*",
    "contactMethod": "Meio de contato",
    "gotAnswerFromClient": "Cliente atendeu?",
    "isImportant": "É importante?",
    "null": "Não se aplica",
    "nextCollectionDate": "Data da próxima interação",
    "willPayAt": "Pagamento acordado?",
    "isAbleToPay": "Pode pagar?",
    "alreadyPaid": "Já pagou?",
    "no": "No",
    "backButton": "Voltar",
    "dni": "CPF",
    "phone": "Telefone",
    "yes": "Sí"
  }
}
</i18n>
<template>
  <div>
    <Spinner v-if="isLoading" />
    <Message v-else-if="messagesClientError.message !== ''" :message="messagesClientError.message" :icon="messagesClientError.icon" />
    <div v-else>
      <div class="default-client-header">
        <div class="header-name">
          <h2 class="title grand-size-text">
            {{ client.name }} {{ client.lastName }}
            <b-button
              v-if="client.defaultingCollectionUserId === currentUserId"
              id="release-client"
              class="is-button-primary ml-2 is-small is-rounded is-pulled-right"
              @click="returnToCollection(true)">
              Liberar
            </b-button>
            <b-button
              v-else
              id="release-client"
              class="is-button-primary ml-2 is-small is-rounded is-pulled-right"
              @click="returnToCollection(false)">
              {{ $t('backButton') }}
            </b-button>
          </h2>
        </div>
      </div>
      <div class="card-item client-info">
        <div class="client-content-buttons" data-cy="client-content-buttons">
          <b-tabs
            v-model="selectedContent"
            expanded
            :size="tabsSize">
            <b-tab-item
              v-for="(value, key) in contentButtons"
              :id="`${value}-data`"
              :key="key"
              :label="value"
              :value="`${key}-data`" />
          </b-tabs>
        </div>
        <div
          v-if="selectedContent === 'contact-data'"
          id="client-contact-data"
          class="med-size-text">
          <div class="client-id-number">
            <span class="has-text-weight-bold">{{ $t('dni') }}</span>
            <span>{{ formatIdNumber(client.idNumber) }}</span>
          </div>
          <div class="client-email">
            <span class="has-text-weight-bold">Email</span>
            <span>{{ client.email }}</span>
          </div>
          <div class="client-phone">
            <span class="has-text-weight-bold">{{ $t('phone') }}</span>
            <span v-if="$i18n.locale === 'pe'">{{ formatPhoneNumberPe(client.phone) }}</span>
            <span v-if="$i18n.locale !== 'pe'">{{ formatPhoneNumber(client.phone) }}</span>
          </div>
          <div class="client-id">
            <span class="has-text-weight-bold">Id cliente</span>
            <span>{{ client._id }}</span>
          </div>
          <div v-if="(client.availabilityInitialHour || client.availabilityEndHour) && ($i18n.locale === 'pe')" class="client-availability-initial-hour">
            <span class="has-text-weight-bold">Horario de visita</span>
            <span>{{ client.availabilityInitialHour || "00:00" }} - <span>{{ client.availabilityEndHour || "23:59" }}</span></span>
          </div>
          <div v-if="client.address && ($i18n.locale === 'br' || $i18n.locale === 'pe')" class="client-id">
            <span class="has-text-weight-bold">{{ $t('address') }}</span>
            <span>{{ client.address }}</span>
          </div>
        </div>
        <div v-if="selectedContent === 'debt-data'" id="client-debt-data">
          <WalletBalance :client-balance="clientBalance" />
          <Message v-if="messagesDebtError.message !== ''" :message="messagesDebtError.message" :icon="messagesDebtError.icon" />
          <div v-else>
            <RelatedTransactions
              v-if="relatedTransactions && relatedTransactions.length > 0"
              :related-transactions="relatedTransactions"
              :payment-providers="paymentProviders"
              :cancel-related-transaction-button="'hide'"
              @open-cancel-transaction-modal="openCancelTransactionModal" />
            <ClientOperations
              v-if="creditList.length !== 0"
              :operations="creditList"
              :client-balance="clientBalance"
              :payments-map="paymentsMap"
              :collect-client-debt="true"
              :current-user-is-client="currentUserIsClient"
              :show-remove-late-charges="client.defaultingCollectionUserId === currentUserId"
              :default-extend-payment-id="defaultExtendPaymentId"
              @remove-late-charges="removeLateCharges"
              @undo-remove-late-charges="undoRemoveLateCharges" />
          </div>
        </div>
        <div
          v-if="selectedContent === 'transaction-data'"
          id="client-transaction-data">
          <Message v-if="messagesDebtError.message !== ''" :message="messagesDebtError.message" :icon="messagesDebtError.icon" />
          <div v-else>
            <router-view
              @open-cancel-transaction-modal="openCancelTransactionModal" />
          </div>
        </div>
        <div
          v-if="selectedContent === 'transactions-data'"
          id="client-payments-data">
          <TransactionsHistory
            :current-user-is-client="currentUserIsClient"
            :client-id="clientId"
            :payment-providers="paymentProviders" />
        </div>
        <div
          v-if="selectedContent === 'boletos-data'"
          id="client-boletos-data">
          <BoletosHistory
            :current-user-is-client="currentUserIsClient"
            :client-id="clientId"
            :payment-providers="paymentProviders" />
        </div>
      </div>
      <InteractionsHistory
        managing-type="SINGLE"
        :loading-interactions.sync="loadingInteractions"
        :interactions.sync="clientDefaults"
        :use-date-filters="true"
        :date-constraints="dateConstraints"
        :current-backoffice-related-user="client.defaultingCollectionUser"
        :fields="interactionFields"
        @create-new-interaction="createNewInteraction($event)"
        @load-interactions="loadInteractions($event)" />
    </div>
    <b-modal v-model="cancellingRelatedTransaction.isModalActive" :width="600">
      <div class="modal-card-body has-text-centered">
        <div class="modal-card-header">
          <div class="is-pulled-right">
            <a class="close-modal" @click="cancellingRelatedTransaction.isModalActive=false">
              <img src="@/ui/assets/img/plus-button.svg">
            </a>
          </div>
          <h3 class="modal-title">Anular Pago</h3>
        </div>
        <section class="modal-card-body">
          <p>
            Al hacer click en "Anular Pago", se descartará el pago creado
            y las cuotas volverán a estar disponibles para ser pagadas. Si
            realizaste una transacción, será necesario que vuelvas a hacer
            el proceso de pago para que sea validada.
          </p>
          <div class="confirmation-buttons">
            <button
              id="cancel-transaction-anulation"
              class="button is-button-secondary is-rounded"
              @click="cancellingRelatedTransaction.isModalActive=false">
              Volver
            </button>
            <button
              id="anulate-transaction"
              class="button is-button-primary is-rounded"
              :disabled="cancellingRelatedTransaction.disabledCancelButton"
              @click="cancelCurrentTransaction">
              Anular Pago
            </button>
          </div>
        </section>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {
  createClientDefault,
  getClient,
  getClientDebtWithInactiveOperations,
  setOrUnsetClientDefaultAsBeingManagedByCurrentUser,
  getClientsWithDefaults
} from '@/application/services/api-clients/clients';
import { getClientsTransactions, getTransactionsProviders } from '@/application/services/api-clients/transactions';
import Message from '@/ui/components/Message.vue';
import Spinner from '@/ui/components/Spinner.vue';
import ClientOperations from '@/ui/components/internal/pay-here/ClientOperations.vue';
import RelatedTransactions from '@/ui/components/internal/pay-here/RelatedTransactions.vue';
import TransactionsHistory from '@/ui/components/internal/pay-here/TransactionsHistory.vue';
import BoletosHistory from '@/ui/components/internal/pay-here/BoletosHistory.vue';
import { formatNumber } from '@/infrastructure/format';
import { dateToFormatedString } from '@/infrastructure/date';
import { setNoLateChargesUntil } from '@/application/services/api-clients/operations';
import WalletBalance from '@/ui/components/internal/pay-here/WalletBalance.vue';
import { debtToCreditList } from '@/domain/helpers';
import { collectionInteractionFields } from '@/domain/constants/collection-interaction-fields';
import InteractionsHistory from '@/ui/components/interactions/InteractionsHistory.vue';

export default {
  name: 'CollectClientDebt',
  components: {
    Message,
    Spinner,
    ClientOperations,
    RelatedTransactions,
    TransactionsHistory,
    BoletosHistory,
    InteractionsHistory,
    WalletBalance
  },
  data() {
    const { clientId } = this.$route.params;
    const date = new Date();
    const contentButtons = {
      contact: this.$t('contactButton'),
      debt: this.$t('debtButton')
    };
    if (this.$i18n.locale === 'cl' || this.$i18n.locale === 'pe') {
      contentButtons.transactions = this.$t('paymentsButton');
    }
    if (this.$i18n.locale === 'cl') {
      contentButtons.transaction = 'Transacción';
    }
    if (this.$i18n.locale === 'br') {
      contentButtons.boletos = 'Boletos';
    }
    return {
      client: {},
      debt: [],
      creditList: [],
      contentButtons,
      clientBalance: 0,
      messagesClientError: { message: '', icon: '' },
      messagesDebtError: { message: '', icon: '' },
      relatedTransactions: [],
      paymentProviders: [],
      paymentsMap: {},
      isLoading: true,
      currentUserIsClient: !!this.$store.state.currentUser.user.clientId,
      clientId,
      extendedOperation: 0,
      extendedPayment: {},
      selectedContent: 'contact-data',
      defaultExtendPaymentId: '',
      tabsSize: 'is-medium',
      loadingInteractions: true,
      clientDefaults: [],
      interactionFields: collectionInteractionFields(this),
      dateConstraints: {
        from: new Date(date.getFullYear(), 0, 1),
        to: new Date(date.getFullYear(), date.getMonth(), date.getDate() + 2)
      },
      cancellingRelatedTransaction: {
        isModalActive: false,
        transactionToCancel: '',
        disabledCancelButton: true
      }
    };
  },
  computed: {
    currentUserId() {
      const { currentUser } = this.$store.state;
      return currentUser ? currentUser.user._id : '';
    }
  },
  async mounted() {
    this.$store.dispatch('setbackOfficeClientId', this.clientId);
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
    try {
      const [client, paymentProviders] = await Promise.all([
        getClient(this.clientId),
        getTransactionsProviders()
      ]);
      this.paymentProviders = paymentProviders;
      this.client = client;
    } catch (_error) {
      this.messagesClientError = {
        message: 'Ocurrió un error al obtener la información del cliente',
        icon: 'data_maintenance.svg'
      };
      this.isLoading = false;
      return;
    }
    await this.loadClientDebt();
    await this.loadInteractions(this.dateConstraints);
    this.isLoading = false;
  },
  methods: {
    onResize() {
      this.tabsSize = window.innerWidth < 500 ? 'is-small' : 'is-medium';
    },
    returnToCollection(unset = false) {
      if (unset) {
        setOrUnsetClientDefaultAsBeingManagedByCurrentUser(this.clientId);
      }
      this.$router.push({ name: 'collection' });
    },
    async loadClientDebt() {
      try {
        // const { debt, clientBalance } = await getClientDebt(this.clientId);
        const { debt, clientBalance } = await getClientDebtWithInactiveOperations(this.clientId);

        // El endpoint de Brasil no retorna el _id, sino cómo operationId
        // eslint-disable-next-line no-param-reassign
        debt.forEach(op => { op._id = op._id ? op._id : op.operationId; });
        this.debt = debt;
        this.creditList = debtToCreditList(debt);

        const doubleInstallment = !!this.creditList.find(obj => !!obj.complementaryOperationId);
        if (doubleInstallment) {
          this.contentButtons = { contact: 'Contacto',
            debt: 'Deuda',
            transactions: 'Pagos' };
        }

        this.clientBalance = clientBalance;
        if (this.debt.length === 0) {
          this.messagesDebtError = {
            message: 'Cliente no tiene mora',
            icon: 'data_maintenance.svg'
          };
        } else {
          const relatedTransactionsIds = debt.reduce((accum, operation) => {
            return operation.payments.reduce((ac, payment) => {
              if (payment.isPending) {
                ac.push(payment.transactionId);
              }
              return accum;
            }, accum);
          }, []);

          const promises = [];
          if (relatedTransactionsIds.length > 0) {
            promises.push(getClientsTransactions(this.clientId, relatedTransactionsIds));
          }
          const [relatedTransactions] = await Promise.all(promises);
          this.relatedTransactions = relatedTransactions;
          this.debt.forEach(operation => {
            this.paymentsMap[operation._id] = operation.payments;
          });
        }
      } catch (_error) {
        this.messagesDebtError = {
          message: 'Ocurrió un error al obtener la deuda del cliente',
          icon: 'data_maintenance.svg'
        };
      }
    },
    async createNewInteraction(interactionToCreate) {
      try {
        await createClientDefault(this.clientId, interactionToCreate);
        const clientData = await getClient(this.clientId);
        this.client = clientData;
      } catch (_error) {
        this.launchToast('Ocurrió un error al crear el registro', 'is-danger');
        return;
      }
      this.$emit('new-interaction-successfully-created');
    },
    async removeLateCharges(eventIn) {
      const event = { ...eventIn };
      event.comment = `Se descuenta gasto de cobranza de la cuota ${event.paymentNumber} de la operación ${event.companyOperationId} hasta ${event.noLateChargesUntil}`;
      await this.manageLateCharges(event);
    },
    async undoRemoveLateCharges(eventIn) {
      const event = { ...eventIn };
      event.comment = `Se reversa el descuento de gasto de cobranza de la cuota ${event.paymentNumber} de la operación ${event.companyOperationId}`;
      event.noLateChargesUntil = '';
      await this.manageLateCharges(event);
    },
    async manageLateCharges(event) {
      this.isLoading = true;
      this.debt = [];
      try {
        const { operationId, paymentNumber, noLateChargesUntil, extendedPaymentId, comment } = event;
        await setNoLateChargesUntil(operationId, paymentNumber, noLateChargesUntil);
        await this.createNewInteraction({ comment, alreadyPaid: false, gotAnswerFromClient: null });
        this.defaultExtendPaymentId = extendedPaymentId;
        await this.loadClientDebt();
        this.launchToast('Gasto de cobranza registrado exitosamente');
        this.isLoading = false;
      } catch (_e) {
        this.launchToast('Ocurrió un error al registrar gastos de cobranza', 'is-danger');
      }
    },
    formatIdNumber(idNumber) {
      if (this.$i18n.locale === 'pe') {
        return idNumber;
      }
      const [number, digit] = idNumber.split('-');
      return `${formatNumber({ number: Number(number) })}-${digit}`;
    },
    formatDate: val => dateToFormatedString(val, 'DD/MM/YYYY'),
    formatPhoneNumber: number => `+${formatNumber({ number, thousandSeparator: ' ', groupOfDigitsLength: 4 })}`,
    formatPhoneNumberPe: number => `(+51) ${formatNumber({ number, thousandSeparator: ' ', groupOfDigitsLength: 3 })}`,
    async loadInteractions(dateConstraints) {
      this.loadingInteractions = true;
      const { from, to } = dateConstraints;
      try {
        const [client] = await getClientsWithDefaults([this.clientId], from, to);
        this.clientDefaults = client.defaults;
      } catch (_error) {
        this.errorMessageForUser = 'Ocurrió un error al tratar de obtener el historial de gestiones de mora';
      }
      this.loadingInteractions = false;
    },
    launchToast(message, type = 'is-info', duration = 5000) {
      this.$buefy.toast.open({
        position: 'is-top-right',
        message,
        type,
        duration
      });
    },
    openCancelTransactionModal(transactionId) {
      if (!transactionId) {
        this.cancellingRelatedTransaction.isModalActive = false;
        this.cancellingRelatedTransaction.transactionToCancel = '';
      } else {
        this.cancellingRelatedTransaction.transactionToCancel = transactionId;
        this.cancellingRelatedTransaction.isModalActive = true;
        this.cancellingRelatedTransaction.disabledCancelButton = false;
      }
    },
    cancelCurrentTransaction() {
      if (!this.cancellingRelatedTransaction.disabledCancelButton) {
        this.cancellingRelatedTransaction.disabledCancelButton = true;
        this.$emit('cancel-transaction', this.cancellingRelatedTransaction.transactionToCancel);
      }
    }
  }
};
</script>
<style scoped>
.grand-size-text {
  font-size: 1.5rem;
}
.big-size-text {
  font-size: 1.2rem;
}
.med-size-text {
  font-size: 0.9rem;
}
.default-client-header {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
  gap: 0rem 1rem;
  place-items: center;
  color: var(--primary);
  font-weight: 600;
}
.default-client-header .header-name {
  justify-self: start;
}
.default-client-header .button {
  justify-self: end;
}
.card-item.client-info {
  z-index: 0; /* Para que el datepicker del eliminar gastos de cobranza pase por arriba del CollectionHistory */
}
.card-item {
  width: auto;
  margin: 0 0 2rem 0;
  padding: 1% 5% 2rem;
  overflow: visible !important;
}
.client-content-buttons {
  margin: 1rem;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-evenly;
  gap: 1rem;
}
.client-content-buttons .selected-content-button {
  background-color: var(--primary);
  color:white;
}
#client-contact-data {
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(13rem, 1fr) );
  grid-gap: 1rem 0rem;
}
#client-contact-data,
#client-debt-data {
  margin: 0 2%;
}
#client-contact-data div {
  display: flex;
  flex-flow: column wrap;
}
@media (max-width: 550px) {
  #client-contact-data,
  #client-debt-data {
    border-radius: 1.5rem;
  }
}
@media (max-width: 350px) {
  .grand-size-text {font-size: 1.2rem;}
  .big-size-text {font-size: 0.9rem;}
  .med-size-text {font-size: 0.75rem;}
}
</style>
